<template>
  <div class="md-layout">
    <div id="objectHeaderContentHidden" style="display: none;">
      <div>
        <md-icon class="icon-color">{{list.pageIcon}}</md-icon>
      </div>
      <div>
        <h1 class="md-title icon-color">{{ $route.name }}</h1>
      </div>
    </div>

    <ElasticList :list="list"></ElasticList>
  </div>
</template>

<script>
import ElasticList from "@/components/DynamicForm/ElasticList";
import Page from '@/mixins/Page';

export default {
  components: {
    ElasticList
  },
  mixins: [Page],
  data() {
    return {
      list: {
        hideListHeader: true,
        editPath: "hq",
        pageTitle: "HQ",
        pageIcon: "business",
        listQueryId: "searchHQs",
        linkRows: true,
        deleteQueryId: "deleteHq",
        columns: {
          name: { label: "Name", sortable: true },
          //IPCorp: { label: "IPCorp", sortable: true },
          createdAt: { label: "CreatedAt", sortable: true, dateFilter: true }
        },
        perPageOptions: [5, 10, 20, 25, 50],
        defaults: {
          sort: "name",
          sortDir: "desc",
          perPage: 10
        },
        fuseSearch: null
      }
    };
  }
};
</script>
